import { DOCUMENT } from '@angular/common';
import { AfterContentInit, Directive, ElementRef, Inject } from '@angular/core';

@Directive({
  selector: 'mat-expansion-panel-header',
  standalone: true,
})
export class ExpansionPanelHeaderContentCheckerDirective
  implements AfterContentInit
{
  constructor(
    private readonly el: ElementRef<HTMLElement>,
    @Inject(DOCUMENT) private readonly doc: Document
  ) {}

  ngAfterContentInit(): void {
    const spanContent: HTMLSpanElement =
      this.el.nativeElement.querySelector('span.mat-content');

    if (spanContent) {
      const newDivContent = this.doc.createElement('div');

      const children: Node[] = [];
      spanContent.childNodes.forEach((childNode) => {
        children.push(childNode);
      });
      newDivContent.append(...children);

      for (let i = 0; i < spanContent.attributes.length; i++) {
        newDivContent.attributes.setNamedItem(
          spanContent.attributes.item(i).cloneNode(true) as Attr
        );
      }

      spanContent.replaceWith(newDivContent);
    }
  }
}
